import { Injectable, EventEmitter } from '@angular/core';
import { Constants } from './constants';

export interface MenuItem {
  screenId: number;
  screenCode: string;
  displayName: string;
  relativePath: string;
  queryString: any;
  children: MenuItem[];
}

export interface LoginResponse {
  message: string;
  token: string;
  user: any;
  warningMessage: string;
  hasOtherSession: boolean;
  code?: string;
  mfaRequired?: boolean;
}

export interface BranchSettingResponse {
  cashGl: any;
}

export interface BranchChange {
  previousBranch: any;
  currentBranch: any;
  currentBank: any;
}

@Injectable()
export class ContextService {
  private _currentBranchSettings: any;
  private _cashGl: number;
  private _isLoggedIn: boolean;
  private _token: string;
  private _user: any;
  private _menu: MenuItem[];
  private _erp:any;
  private _currentBranchId: number;
  private _currentBranch: any;
  private _currentBank: any;
  private _currentBranchPermissions: any;
  private _currentDate: Date;
  private _homeBranchId: number;
   private _bankName: any;
  private _homeBranch: any;
  private _branchId:number;
   private _cashLimit: any;
  public contextChanged: EventEmitter<any>;
  public branchChanged: EventEmitter<BranchChange>;
  public redirectUrl: string;
     private _logo: any;
     private _warningMessage: string;
  private _glAccessList: any[] = [];


  constructor(private constants: Constants) {
    this._isLoggedIn = false;
    this._token = '';
    this._user = null;
    this._menu = [];
    this._warningMessage = '';
    this.contextChanged = new EventEmitter<any>();
    this.branchChanged = new EventEmitter<BranchChange>();
    // this._cashGL = ''

    const existingToken = sessionStorage.getItem('Jwt');
    if (existingToken !== null && existingToken !== undefined) {
      this._isLoggedIn = true;
      this._token = existingToken;
      this._user = JSON.parse(sessionStorage.getItem('User'));
      this._warningMessage = sessionStorage.getItem('WarningMessage');
     // alert(JSON.stringify(this._user));
      // this.setCurrentBranchValues(this._user.homeBranch.id);
      this._homeBranchId = this._user.homeBranch.id;
      this._homeBranch = this._user.homeBranch;

     // this._cashLimitId= this._user._cashLimit.id;
    
       this._cashLimit=this.user._cashLimit;
      this._logo = "data:"+this._user.currentBank.imageType + ";base64,"+ this._user.currentBank.documentImage;
       this._currentBranchId = this._user.currentBranch.id;
      this._currentBranch = this._user.currentBranch;
      this._currentBank = this._user.currentBank;
      this._currentBranchPermissions = this._user.currentBranchPermissions;

      this._currentBranchSettings = JSON.parse(sessionStorage.getItem('CurrentBranchSettings'));
      if (this._currentBranchSettings) {
        this._currentDate = this._currentBranchSettings.currentBranchDate;
        this._branchId = this._currentBranchSettings.branchId;
      }
   
      
     // Look for 'CashGL' inside your constructor `if (existingToken !== null...)` block:
const cachedCashGl = sessionStorage.getItem('CashGL');
if (cachedCashGl) {
  this._cashGl = JSON.parse(cachedCashGl);
}

      const menuData = sessionStorage.getItem('Menu');
      if (menuData && menuData !== '') {
        this._menu = JSON.parse(menuData);
      }
    }

    console.log('Emiting context changed ctor');
    this.contextChanged.emit();
  }

  public get currentBranchId(): number {
    return this._currentBranchId;
  }

  public get glAccessList(): any[] {
    return this._glAccessList;
  }
   public get logo(): any {
    return this._logo;
  }

  public get currentBranch(): any {
    return this._currentBranch;
  }

   public get currentBank(): any {
    return this._currentBank;
  }
  public get homeBranchId(): number {
    return this._homeBranchId;
  }
  
  public get homeBranch(): any {
    return this._homeBranch;
  }
  public get branchId():any{
    return this._branchId;
  }
  // public get cashLimitId(): number {
  //   return this._cashLimitId;
  // }
    public get cashLimit(): any {
      return this._cashLimit;
   }

  public get isLoggedIn(): boolean {
    return this._isLoggedIn;
  }

  public get token(): string {
    return this._token;
  }
  public get cashGl(): Number{
    return this._cashGl;
  }

  public get user(): any {
    return this._user;
  }

  public get warningMessage(): string {
  return this._warningMessage;
}

  public get menu(): MenuItem[] {
    return this._menu;
  }
  public get erp(): any {
    return this._erp;
  }
  public get currentDate(): Date {
  const parsedDate = new Date(this._currentDate);
  return parsedDate.getFullYear() > 1900 ? parsedDate : new Date(); // fallback to current date
}
public get currentBranchSettings(): any {
    return this._currentBranchSettings;
  }
public setBranchData(response: BranchSettingResponse): void {
  this._cashGl = response.cashGl;
  // Add this line to persist data through page refreshes:
  sessionStorage.setItem('CashGL', JSON.stringify(response.cashGl));
}

  public setLoginData(response: LoginResponse): void {
    const isMfaResponse = response.code === 'MFA_REQUIRED';
    const isSuccessResponse = response.message === '' || response.code === 'Success';
    if (isSuccessResponse || isMfaResponse) {
      this._isLoggedIn = true;
      this._token = response.token || '';
      this._user = response.user;
      if (response.user) {
        this._currentBranchId = response.user.currentBranch?.id;
        this._currentBranch = response.user.currentBranch;
        this._currentBank = response.user.currentBank;
        this._homeBranchId = response.user.homeBranch?.id;
        this._branchId = response.user.branchId;
        this._homeBranch = response.user.homeBranch;
        this._bankName = response.user.bankName;
        this._cashLimit = response.user.cashLimit;
        this._currentBranchPermissions = response.user.currentBranchPermissions;
        this._logo = this._logo;
        this._warningMessage = response.warningMessage || '';

        sessionStorage.setItem('Jwt', this._token);
        sessionStorage.setItem('User', JSON.stringify(response.user));
        if (this._warningMessage) {
          sessionStorage.setItem('WarningMessage', this._warningMessage);
        }
      } 
    }
  }

  public clearLoginData(): void {
    this._isLoggedIn = false;
    this._token = '';
    this._user = null;
    this._menu = [];
    this._currentBranch = null;
    this._currentBank = null;
    this._currentBranchPermissions = null;
    this._currentBranchId = -1;
    this._currentDate = null;
    this._branchId=null;
    this._homeBranch = null;
    this._homeBranchId = -1;
     this._cashLimit = null;
   // this._cashLimitId = -1;
  //  this._branchId = null;
    sessionStorage.removeItem('Jwt');
    sessionStorage.removeItem('User');
    sessionStorage.removeItem('Menu');
    sessionStorage.removeItem('CurrentBranchSettings');
   // sessionStorage.removeItem('CashGL')

    console.log('Emiting context changed clearLoginData');
    this.contextChanged.emit();
  }

  public setGlAccessList(list: any[]): void {
  this._glAccessList = list;
  sessionStorage.setItem('GlAccessList', JSON.stringify(list));
}

  public setCurrentBranchSettings(branchSettings: any) {
    this._currentBranchSettings = branchSettings;
    this._currentDate = branchSettings.currentBranchDate;
    this._branchId = branchSettings.branchId;
    sessionStorage.setItem('CurrentBranchSettings', JSON.stringify(branchSettings));

    console.log('Emiting context changed setCurrentBranchSettings');
    this.contextChanged.emit();
  }

  public setCurrentBranch(branchId: number): void {
    /* if (this._currentBranchId === branchId) {
      return;
    }

    const prevBranch = this.setCurrentBranchValues(branchId);

    this.branchChanged.emit({
      previousBranch: prevBranch,
      currentBranch: this._currentBranch
    });

    console.log('Emiting context changed setCurrentBranch');
    this.contextChanged.emit(); */
  }

  public setMenuItems(menuItems: Array<MenuItem>): void {
    this._menu = menuItems.slice();
    sessionStorage.setItem('Menu', JSON.stringify(this._menu));
  }

  public hasAnyScreenPermission(screenCodes: Array<string>): boolean {
    let screenEnabled = false;

    for (const screenCode of screenCodes) {
      const actions = this.getScreenActions(screenCode);
      if (actions !== -1) {
        screenEnabled = true;
        break;
      }
    }

    return screenEnabled;
  }

  public hasActionPermission(screenCodes: Array<string>, actionToCheck: number): boolean {
    let actionEnabled = false;
    for (const screenCode of screenCodes) {
      const actions = this.getScreenActions(screenCode);
      if (actions !== -1) {
        actionEnabled = this.isActionEnabled(actions, actionToCheck);
      }
    }

    return actionEnabled;
  }

  // private setCurrentBranchValues(branchId: number): any {
  //   /* if (this._currentBranchId === branchId) {
  //     return;
  //   }

  //   const prevBranch = this._currentBranch;
  //   this._currentBranchId = branchId;

  //   const branchData = this.getBranchData(branchId);
  //   this._currentBranchPermissions = branchData;
  //   this._currentBranch = branchData.branch;

  //   return prevBranch; */
  // }

  private getScreenActions(screenCode: string): number {

    if (this.constants.Screen.hasOwnProperty(screenCode) === true) {
      const screenKey = this.constants.Screen[screenCode];
      return this._currentBranchPermissions.screensAndActions[screenKey];
    }

    return -1;
  }

  private isActionEnabled(allowedActions: number, actionToCheck: number): boolean {
    let found = false;

    if ((actionToCheck & allowedActions) !== 0) {
      found = true;
    }

    return found;
  }
}
